import React from "react";
import {
  Article,
  Section,
  SectionHeader,
  SectionTitle,
} from "../../styles/ResumeStyles";

const Education = () => {
  return (
    <Article>
      <Section>
        <SectionHeader>
          <SectionTitle>Education</SectionTitle>
        </SectionHeader>
        <p>
          <b>Bachelor of Architecture</b> - National Institute of Technology -
          Trichy (2019)
        </p>
      </Section>
    </Article>
  );
};

export default Education;
